import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_PREFIX, BASE_URL } from '@CONSTANTS/API.constant';
import userRepository from '@REPOSITORIES/local-repository/user-repository';
import { Workspace } from '@INTERFACES/api/workspaces';

export const workspacesApi = createApi({
    reducerPath: 'workspaces-api',
    baseQuery: fetchBaseQuery({
        baseUrl: BASE_URL + API_PREFIX,
        prepareHeaders: (headers) => {
            const token = userRepository.getData();

            if (token) {
                headers.set('Authorization', `Bearer ${token}`);
            }

            return headers;
        },
    }),
    tagTypes: ['Workspace'],
    endpoints: (builder) => ({
        getAll: builder.query<Workspace[], void>({
            query: () => '/workspaces/',
            providesTags: ['Workspace'],
        }),
    }),
});

export const {
    useGetAllQuery: useGetAllWorkspaces,
} = workspacesApi; 